import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onMounted } from 'vue';

  interface Contato {
    whatsappNumber: string;
    whatsappMessage: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppButton',
  setup(__props) {

  const contato = ref<Contato | null>(null);

  const fetchContato = async () => {
  const HYGRAPH_ENDPOINT = process.env.VUE_APP_HYGRAPH_URL;

    const query = `
      query GetContato {
        contacts(first: 1) {
          whatsappNumber
          whatsappMessage
        }
      }
    `;

    try {
      const response = await fetch(HYGRAPH_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query })
      });
      const { data } = await response.json();

      if (data.contacts.length > 0) {
        contato.value = data.contacts[0];
      }
    } catch (error) {
      console.error("Erro ao carregar dados de contato:", error);
    }
  };

  const formatMessageForWhatsapp = (message: string) => {
    message = message
      .replace(/<strong>(.*?)<\/strong>/g, '*$1*')
      .replace(/<em>(.*?)<\/em>/g, '_$1_')
      .replace(/<s>(.*?)<\/s>/g, '~$1~')
      .replace(/<p>/g, '').replace(/<\/p>/g, '\n');

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = message;
    const finalMessage = tempDiv.textContent || tempDiv.innerText || "";

    return encodeURIComponent(finalMessage.trim());
  };


  const openWhatsApp = () => {
    if (contato.value) {
      const phone = contato.value.whatsappNumber.replace(/\D/g, '').replace(' ','');

      var message = formatMessageForWhatsapp(contato.value.whatsappMessage);

      const url = `https://wa.me/${phone}?text=${(message)}`;
      window.open(url);
    }
  };

  onMounted(fetchContato);

return (_ctx: any,_cache: any) => {
  return (contato.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "whatsapp-btn",
        onClick: openWhatsApp
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
          alt: "WhatsApp"
        }, null, -1)
      ]))]))
    : _createCommentVNode("", true)
}
}

})